export type AppIconColor =
  | "black"
  | "gray-100"
  | "gray-200"
  | "gray-300"
  | "gray-400"
  | "gray-500"
  | "white"
  | "green"
  | "red"
  | "blue-gray"
  | "primary";

export const iconColors: Map<AppIconColor, string> = new Map();

iconColors.set("black", "#000");
iconColors.set("gray-100", "#E5E6E8");
iconColors.set("gray-200", "#CACDD1");
iconColors.set("gray-300", "#B0B4BB");
iconColors.set("gray-400", "#959BA4");
iconColors.set("gray-500", "#7B828D");
iconColors.set("white", "#FFF");
iconColors.set("green", "#1CB394");
iconColors.set("red", "#F05757");
iconColors.set("blue-gray", "#283847");
iconColors.set("primary", "var(--primary-color)");

export function getIconColorHex(iconColor: AppIconColor | string): string {
  const color = iconColors.get(<AppIconColor>iconColor);

  if (color === undefined) {
    return iconColor;
  }

  return color;
}
